export const LEGAL_UPDATED = '15 de septiembre de 2026';

// Sustituir estos campos cuando el cliente confirme los datos fiscales y contractuales.
// Se dejan visibles para evitar publicar información inventada.
export const LEGAL_OWNER = {
  commercialName: 'Speak English Now',
  legalName: '[PENDIENTE: nombre completo o razón social]',
  taxId: '[PENDIENTE: NIF/CIF]',
  address: '[PENDIENTE: domicilio fiscal o profesional]',
  registry: '[PENDIENTE: datos registrales, si corresponde]',
  email: 'info@speakenglishnow.club',
  phone: '+34 650 492 859',
};
